import React, { useState, useEffect } from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Form, Input } from 'antd';
import getControlloTelefonoCellulare from '../../../redux/actions/mock/getControlloTelefonoCellulare';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import salvaStep from '../../../redux/actions/mock/salvaStep';
import * as actionTypes from '../../../redux/actions/actionTypes';
import Navigation from '../../Navigation/Navigation';

const Contatti = props => {
  const datiState = useSelector(state => state.dataReducer);
  const [form] = Form.useForm();
  const loadingStep = useSelector(state => state.dataReducer.load.loadingStep);
  const numPratica = datiState.modello.numPratica;

  const errorMessageTelefonoCellulare = useSelector(
    state => state.dataReducer.controlloTelefonoCellulare.errorMessage
  );
  const apiPath = useSelector(state => state.dataReducer.dataApiPath);

  const erroriSalvaStep = useSelector(
    state => state.dataReducer.salvaStep.dati
  );

  const [errorMessageCellulare, setErrorMessageCellulare] = useState(null);
  const [errorMessageEmail, setErrorMessageEmail] = useState(null);
  const [errorMessageConfermaEmail, setErrorMessageConfermaEmail] =
    useState(null);
  const [campiValidi, setCampiValidi] = useState(false);

  const datiTokenInBank = useSelector(
    state => state.dataReducer.datiTokenInBank
  );
  const [disabledEmail, setDisabledEmail] = useState(false);
  const [disabledConfermaEmail, setDisabledConfermaEmail] = useState(false);
  const [disabledCellulare, setDisabledCellulare] = useState(false);

  useEffect(() => {
    if (datiTokenInBank) {
      setDisabledEmail(setDisabledItem('email'));
      setDisabledConfermaEmail(setDisabledItem('confermaEmail'));
      setDisabledCellulare(setDisabledItem('cellulare'));
    }

    setTimeout(() => {
      const { email, confermaEmail, cellulare } = form.getFieldsValue([
        'email',
        'confermaEmail',
        'cellulare',
      ]);

      if (datiTokenInBank || email || confermaEmail || cellulare) {
        verificaCampi();
      }
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (erroriSalvaStep) {
      erroriSalvaStep.forEach(errore => {
        switch (errore.errorCode) {
          case 'email':
            setErrorMessageEmail(errore.errorMessage);
            break;
          case 'cellulare':
            setErrorMessageCellulare(errore.errorMessage);
            break;
          default:
            setErrorMessageCellulare(null);
            setErrorMessageEmail(null);
            setErrorMessageConfermaEmail(null);
            break;
        }
      });
    } else {
      setErrorMessageCellulare(null);
      setErrorMessageEmail(null);
      setErrorMessageConfermaEmail(null);
    }
  }, [erroriSalvaStep]);

  const dispatch = useDispatch();

  function notCopyPate(e) {
    e.preventDefault();
    return false;
  }

  function controlloCellulare(e) {
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value)) {
      if (e.target.value.length >= 10) {
        dispatch(getControlloTelefonoCellulare(e.target.value, 'M', apiPath));
      }
    } else {
      form.setFieldsValue({
        cellulare: e.target.value.replace(/\D+/g, ''),
      });
    }
    verificaCampi();
  }

  function controlloEmail(e) {
    setErrorMessageEmail(null);
    const emailValue = e.target.value.toLowerCase();

    // Controlla se supera i 50 caratteri
    if (emailValue.length > 50) {
      setErrorMessageEmail("L'email non può superare i 50 caratteri");
      return;
    }

    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
    if (re.test(emailValue)) {
      form.setFieldsValue({
        email: emailValue,
      });
    } else {
      setErrorMessageEmail('La tua email non è valida..');
    }
    verificaCampi();
  }

  function controlloConfermaEmail(e) {
    setErrorMessageConfermaEmail(null);
    const emailValue = e.target.value.toLowerCase();

    // Controlla se supera i 50 caratteri
    if (emailValue.length > 50) {
      setErrorMessageConfermaEmail("L'email non può superare i 50 caratteri");
      return;
    }

    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
    if (re.test(emailValue)) {
      form.setFieldsValue({
        confermaEmail: emailValue,
      });
    } else {
      setErrorMessageConfermaEmail('La tua email non è valida..');
    }
    verificaCampi();
  }

  function verificaCampi() {
    setTimeout(() => {
      const values = form.getFieldsValue();
      const errors = form.getFieldsError();

      const tuttiCompilati =
        values.email && values.confermaEmail && values.cellulare;
      const nessunoErrore = !errors.some(field => field.errors.length > 0);
      const nessunoErroreCustom =
        !errorMessageEmail &&
        !errorMessageConfermaEmail &&
        !errorMessageCellulare &&
        !errorMessageTelefonoCellulare;

      setCampiValidi(tuttiCompilati && nessunoErrore && nessunoErroreCustom);
    }, 100);
  }

  function valoriIniziali() {
    let datiRicavati = {};
    const richiesta = datiState.modello.datiPratica || {};
    let nuovaRichiesta = sostituisciDate(richiesta);
    datiRicavati = Object.assign(datiRicavati, nuovaRichiesta);
    return datiRicavati;
  }

  function sostituisciDate(obj) {
    let step = obj;
    let newStep = {};
    Object.entries(step).forEach(([chiave, dato]) => {
      if (moment(dato, 'YYYY-MM-DD', true).isValid()) {
        Object.assign(newStep, { [chiave]: moment(dato, 'YYYY-MM-DD') });
      } else if (moment(dato, 'YYYY-MM', true).isValid()) {
        Object.assign(newStep, { [chiave]: moment(dato, 'YYYY-MM') });
      } else {
        Object.assign(newStep, { [chiave]: dato });
      }
    });
    return newStep;
  }

  function sostituisciDateSalvaStep(obj) {
    let step = obj;
    let newStep = {};
    Object.entries(step).forEach(([chiave, dato]) => {
      if (moment(dato, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
        if (
          chiave === 'tempoResidenza' ||
          chiave === 'dataInizioAttivita' ||
          chiave === 'dataFineAttivita'
        ) {
          Object.assign(newStep, { [chiave]: moment(dato).format('YYYY-MM') });
        } else {
          Object.assign(newStep, {
            [chiave]: moment(dato).format('YYYY-MM-DD'),
          });
        }
      } else {
        Object.assign(newStep, { [chiave]: dato });
      }
    });
    return newStep;
  }

  function onFinish(values) {
    let valoriDaSalvare = values;
    let nuoviValori = sostituisciDateSalvaStep(valoriDaSalvare);
    dispatch({ type: actionTypes.LOADING_TRUE });
    dispatch({ type: actionTypes.SALVA_DATI, payload: nuoviValori });
    dispatch(
      salvaStep(
        datiState.modello.datiPratica,
        datiState.modello.id,
        datiState.modello.codiceBroker,
        datiState.modello.currentStep,
        apiPath,
        numPratica
      )
    );
  }

  const setDisabledItem = field => {
    if (datiTokenInBank) {
      let elem = datiTokenInBank.find(item => item.field === field);
      if (elem) {
        return !JSON.parse(elem.editable);
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <div className={stylesForm.Form}>
      <HeaderStep titolo="Informazioni di contatto" sottotitolo="" />

      <Form form={form} onFinish={onFinish} initialValues={valoriIniziali()}>
        <Form.Item
          name="email"
          help={errorMessageEmail ? errorMessageEmail : null}
          rules={[
            {
              type: 'email',
              message: 'La tua email non è valida..',
            },
            {
              required: true,
              message: 'Inserisci la tua email!',
            },
            {
              max: 50,
              message: 'Email troppo lunga (massimo 50 caratteri)',
            },
          ]}>
          <Input
            onChange={controlloEmail}
            maxLength={50}
            disabled={disabledEmail}
            autoComplete="new-password"
            onPaste={notCopyPate}
            placeholder="email"
            suffix={
              <label className={stylesForm.floatingLabel} htmlFor="email">
                Email*
              </label>
            }
          />
        </Form.Item>

        <Form.Item
          name="confermaEmail"
          dependencies={['email']}
          help={errorMessageConfermaEmail ? errorMessageConfermaEmail : null}
          rules={[
            {
              type: 'email',
              message: 'La tua email non è valida..',
            },
            {
              required: true,
              message: 'Inserisci di nuovo la tua email!',
            },
            {
              max: 50,
              message: 'Email troppo lunga (massimo 50 caratteri)',
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (
                  !value.toUpperCase() ||
                  getFieldValue('email').toUpperCase() === value.toUpperCase()
                ) {
                  return Promise.resolve();
                }
                return Promise.reject('Le due email inserite non combaciano');
              },
            }),
          ]}>
          <Input
            onChange={controlloConfermaEmail}
            maxLength={50}
            autoComplete="new-password"
            disabled={disabledConfermaEmail}
            onPaste={notCopyPate}
            placeholder="confermaEmail"
            suffix={
              <label
                className={stylesForm.floatingLabel}
                htmlFor="confermaEmail">
                Conferma Email*
              </label>
            }
          />
        </Form.Item>

        <Form.Item
          name="cellulare"
          help={
            errorMessageTelefonoCellulare
              ? errorMessageTelefonoCellulare
              : errorMessageCellulare
                ? errorMessageCellulare
                : null
          }
          rules={[
            {
              required: true,
              message: 'Inserisci il tuo cellulare!',
            },
          ]}>
          <Input
            onChange={controlloCellulare}
            disabled={disabledCellulare}
            minLength={9}
            maxLength={10}
            placeholder="cellulare"
            suffix={
              <label className={stylesForm.floatingLabel} htmlFor="cellulare">
                Cellulare*
              </label>
            }
          />
        </Form.Item>

        <Navigation
          loadingStep={loadingStep}
          bloccoAvanzamento={
            !campiValidi ||
            errorMessageTelefonoCellulare ||
            errorMessageCellulare ||
            errorMessageEmail ||
            errorMessageConfermaEmail
              ? true
              : false
          }
        />
      </Form>
    </div>
  );
};

export default Contatti;
